"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
// 为了确保在一个页面中存在多panda版本，保持同一个panda context，故如果在window对象上已经存在panda context则使用之
// HACK 寻找更好的办法
var localeContext = window.__PANDA.pandaContext || react_1.default.createContext({
    locale: {},
    _lang: undefined,
    lang: undefined,
    $i18n: undefined,
});
// write for global
if (!window.__PANDA.pandaContext) {
    window.__PANDA.pandaContext = localeContext;
}
exports.default = localeContext;
